/* eslint-disable */
import Vue from 'vue';
import ShardsVue from 'shards-vue';
// Styles
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'bootstrap/dist/css/bootstrap.css';
import '@/scss/main.scss';
// Core
import App from './App.vue';
import router from './utils/router/router';
import store from './utils/store/store'
// Layouts
import Default from '@/layouts/Default.vue';

import i18n from "./i18n";

//Ventanas modales
import VueJsModal from 'vue-js-modal'

Vue.use(ElementUI, {
    i18n: (key, value) => {
        return i18n.t(key, value);
    }
});

ShardsVue.install(Vue);

Vue.component('default-layout', Default);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

Vue.use(VueJsModal, {
    dialog: true,
    dynamicDefaults: {
      draggable: true
    }
  })
  
new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
